import { Spin as AntSpin } from 'antd'
import type { ComponentProps } from 'react'

type AntSpinProps = ComponentProps<typeof AntSpin>

export interface AppSpinProps extends AntSpinProps {}

export const AppSpin = (props: AppSpinProps) => <AntSpin {...props} />
